import { inject } from 'aurelia-framework';
import { customAttribute } from 'aurelia-templating';

/**
 * Used to trap focus on a modal dialog. This is an interim solution. See below for a more permanent solution:
 *
 * https://github.com/aurelia/dialog/pull/338 fixes the issue of tabbing off the dialog. Waiting for new release of aurelia-dialog.
 */
@customAttribute('trap-focus')
@inject(Element)
export class TrapFocus {
	private element: HTMLElement;

	constructor(element: HTMLElement) {
		this.element = element;
	}

	public attached() {
		document.addEventListener('keyup', this.keyPress);
	}

	public detached() {
		document.removeEventListener('keyup', this.keyPress);
	}

	private keyPress = (e: KeyboardEvent) => {
		const key = e.which || e.keyCode;
		if (
			key === 9 &&
			this.element.offsetParent &&
			!this.element.contains(e.srcElement as HTMLElement)
		) {
			const elements = Array.from(
				this.element.querySelectorAll(
					'input:not(disabled), textarea:not(disabled), button:not(disabled), [tabindex]',
				),
			).filter((el: HTMLElement) => el.tabIndex >= 0);

			const next = elements[
				e.shiftKey ? elements.length - 1 : 0
			] as HTMLElement;
			next.focus();
		}
	};
}
